import { render, staticRenderFns } from "./ViewStudentAnswers.vue?vue&type=template&id=522dda50&scoped=true&"
import script from "./ViewStudentAnswers.vue?vue&type=script&lang=js&"
export * from "./ViewStudentAnswers.vue?vue&type=script&lang=js&"
import style0 from "./ViewStudentAnswers.vue?vue&type=style&index=0&id=522dda50&lang=scss&scoped=true&"
import style1 from "./ViewStudentAnswers.vue?vue&type=style&index=1&id=522dda50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522dda50",
  null
  
)

export default component.exports